"use client";

export function CurrencyToggleClient() {
	// USD-only deployment — no currency switcher.
	return null;
}
